import VerticalCard from "@src/app/components/ArticleCard/VerticalCard";
import SectionContainer from "@src/app/components/SectionContainer";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

/**
 * Top Articles
 * @description use in Common Category Page
 */
export default function TopArticles() {
  const route = useRouteResponse("sectionPage");
  const articles = route.topArticlesByCategory || [];

  if (!articles.length) {
    return null;
  }

  return (
    <SectionContainer title={`热门${route.sectionName}`}>
      <div className="justify-items-center lg:grid lg:grid-cols-4">
        {articles.map((article, index) => {
          return (
            <div
              className="!m-0 w-full px-[12px] py-[16px] lg:w-[236px] xxl:w-[300px]"
              key={article.id + index}
            >
              <VerticalCard className="!m-0 w-full" article={article} />
            </div>
          );
        })}
      </div>
    </SectionContainer>
  );
}
